<template>

  <div style="background: white;">
<!--    <div class="template-options-btn mt-12 download float-right mr-12" >-->
<!--      <vs-button   class="template-options-btn-icon " v-on:click="personalityReport()">-->
<!--        <feather-icon-->
<!--          svgClasses="text-white"-->
<!--          icon="DownloadIcon"-->
<!--        />-->
<!--        <span class="template-options-btn-text"> Personality</span>-->
<!--      </vs-button>-->
<!--    </div>-->
<!--    {{personality}}-->
          <section slot="pdf-content"   >
           <div class="iframe-container" v-if="personality.personalityYoulabProgress===2 && personality.personalityYoulabProgress!==null">
           <iframe id="myIFrame" ref="personalityReports"
            :src="'https://lab.getboarded.com/profiles/view'+personality.personalityYoulabToken"
            class="w-full h-full border-0 "
                  crossorigin="anonymous"
           >
           </iframe>
           </div>
<!--      <div  v-if="personality.personalityYoulabProgress===0 && personality.personalityYoulabProgress!==null">-->
<!--        <div class="report-not-generated">-->
<!--          <p class="text-center report-not-generated"  style="font-size: 40px;background-color: rgba(0, 0, 0, 0.0); ">Please Complete Your Infographic Resume</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-else>-->
<!--        <div class="report-not-generated">-->
<!--          <p class="text-center report-not-generated"  style="font-size: 40px;background-color: rgba(0, 0, 0, 0.0); ">Report will be generated after a minimum 4 feedbacks are received</p>-->
<!--        </div>-->
<!--      </div>-->
    </section>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  name: "Main",
  data() {
    return {
      htmlToPdfOptions: {},
    };
  },
  created() {
    if (this.$store.state.auth.user._id) {
       this.$vs.loading();
      this.popup=false;
      console.log('data ddsd',this.$store.state.auth.user._id);
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
           this.$vs.loading.close();
        })
    }
  },
  mounted() {
    if (this.isUserLoggedIn) {
      this.popup=false;
    //  this.$vs.loading();
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
         // this.$vs.loading.close();
        })
    }
    },
  computed: {
      userData() {
        return this.$store.state.auth.user;
      },
      personality() {
        console.log('personality',this.$store.state.editor.personality)

      return this.$store.state.editor.personality;
      },
  },
  methods: {
    personalityReport() {
    console.log('hello');
     //  const doc = new jsPDF();
     //  // var myIFrame = document.getElementById("frame");
     //  // var content = myIFrame.contentDocument.document.body.innerHTML;
     //  // alert(content);
     // // var content = myIFrame.contentDocument;
       console.log('content',this.$refs.personalityReports.contentWindow);
     //
     //   let vOffset = vOffset + 10;
     //  // doc.text(25, vOffset, 'Data Flows')
     //  //var iFrameBody = this.$refs.content;
     //  doc.fromHTML(myIFrame, 15, vOffset)
     //  doc.save("sample.pdf")
      this.generatePDF();
      },
    async generatePDF() {
      // this.$refs.html2Pdf.generatePdf();

      /*html2pdf(this.$refs.prestigeDocument, {
					margin: 0,
					filename: `${this.userData.firstName}-${this.userData.lastName}.pdf`,
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: {scale: 4, dpi: 192, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
          enableLinks: true,
          pagebreak: { mode: ['avoid-all'] },
				}).then(() => {
          this.$vs.loading.close();
        })*/

      const pdfName = `${this.userData.firstName}-${this.userData.lastName}.pdf`;
      const vsLoading = this.$vs.loading;

      await html2canvas(this.$refs.personalityReports.contentWindow).then(function (canvas) {
        var a = document.createElement('a');
        // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
        a.href = canvas.toDataURL("image/jpeg", 1.0);
         a.download = 'somefilename.jpeg';
         a.click();

        const img = new Image();
        img.onload = async function() {
          // // console.log(this.width + 'x' + this.height);
          let pdf = new jsPDF('p', 'px', [this.width, this.height]);
          if(this.width > this.height) {
            pdf = new jsPDF('l', 'px', [this.width, this.height]);
          }
          await pdf.addImage(a.href, 'JPEG', 0, 0, this.width, this.height);
          await pdf.save(pdfName);
          vsLoading.close();
        }
        img.src = a.href;
      });
    },
    startPagination() {
      // this.$vs.loading();
    },
    onProgressDownload(ev) {},
    hasDownloaded() {
      this.$vs.loading.close();
    },
    async imgToBase64(img) {
      let imgRes = "";
      await imageToBase64(img)
        .then((res) => {
          imgRes = res;
          return res;
        })
        .catch((err) => {
          throw err;
        });

      return imgRes;
    },
    paraToList(para) {
      if (para) {
        let lst = para.match(/[^\.!\?]+[\.!\?]+/g);
        if (lst && lst.length) {
          return lst;
        } else {
          return [para];
        }
      }
      return [];
    },
  },


};
</script>
<style scoped>

@charset "utf-8";
.iframe-container {
  height: 6500px;
  margin-top: 6rem;
}
.download {
  margin-top:1rem;
}
.report-not-generated {
  height: 100vh;
  padding: 10rem;
}
</style>
